<div class="template-container">
  <div style="height: 100%; width: 100%">
    <div
      style="height: 100%; display: flex; flex-direction: column"
      [hidden]="!isCreating"
    >
      <ion-toolbar *ngIf="template">
        <div style="display: flex">
          <ion-title>
            <a
              style="font-size: 1rem; margin-right: 14px"
              (click)="checkIfShouldGoBack()"
            >
              <ion-icon name="chevron-back-outline"></ion-icon>
            </a>
            <span class="template-top-title" (click)="editTemplate()">{{
              template.name
            }}</span>
            <a
              style="font-size: 1rem; margin-left: 14px"
              (click)="editTemplate()"
              [hidden]="isReadOnly"
            >
              <ion-icon name="create-outline"></ion-icon>
            </a>
          </ion-title>
          <div style="margin: 10px">
            <ion-button
              color="dark"
              fill="clear"
              [disabled]="true"
              *ngIf="isReadOnly"
            >
              You are editing a sample
            </ion-button>
            <span *ngIf="!isReadOnly">
              <ion-button
                color="warning"
                shape="round"
                (click)="showWarnings()"
                [hidden]="!warning"
                class="action-button"
              >
                <ion-icon name="warning-outline"></ion-icon>
                1
              </ion-button>
              <ion-button
                [color]="template.id ? 'light' : 'success'"
                (click)="save()"
                [disabled]="isLoading"
                class="action-button"
              >
                <ion-icon
                  name="checkmark-outline"
                  *ngIf="!template.id"
                  class="padded-icon"
                ></ion-icon>
                Save
              </ion-button>
            </span>
            <ion-button
              [color]="isReadOnly ? 'success' : 'light'"
              (click)="clone()"
              [disabled]="isLoading"
              class="action-button"
              *ngIf="template.id"
            >
              <ion-icon
                name="duplicate-outline"
                *ngIf="isReadOnly"
                class="padded-icon"
              ></ion-icon>
              Save as...
            </ion-button>
            <span *ngIf="!isReadOnly">
              <ion-button
                (click)="sendEmail()"
                [disabled]="isLoading"
                *ngIf="template.id && template.type === 'email'"
                class="action-button"
              >
                <ion-icon
                  name="mail-outline"
                  class="padded-icon"
                  [hidden]="isFetchingMembers"
                ></ion-icon>
                <ion-spinner
                  name="crescent"
                  style="margin-right: 10px"
                  [hidden]="!isFetchingMembers"
                ></ion-spinner>
                Compose
              </ion-button>
              <ion-button
                (click)="sendSlack()"
                [disabled]="isLoading"
                *ngIf="template.id && template.type === 'slack'"
                class="action-button"
              >
                <ion-icon
                  name="logo-slack"
                  class="padded-icon"
                  [hidden]="isFetchingMembers"
                ></ion-icon>
                <ion-spinner
                  name="crescent"
                  style="margin-right: 10px"
                  [hidden]="!isFetchingMembers"
                ></ion-spinner>
                Compose
              </ion-button>
            </span>
          </div>
        </div>
      </ion-toolbar>

      <app-unlayer-wrapper
        style="height: 100%"
        (loaded)="editorLoaded()"
        [hidden]="!template || template.type !== 'email'"
        [options]="unlayerOptions()"
      >
      </app-unlayer-wrapper>
      <app-slack-blocks
        [blocks]="blocks"
        [communityId]="communityId"
        [project]="template.project"
        *ngIf="
          template &&
          template.type === 'slack' &&
          (!template.projectId || template.project)
        "
      >
      </app-slack-blocks>
    </div>

    <div [hidden]="isCreating">
      <div class="empty-state-container">
        <span class="placeholder-emoji">🛠</span>
        <h1 class="placeholder-title">Welcome to the template builder</h1>
        <p class="placeholder-subtitle">
          Create custom Slack and email designs to easily reuse.
        </p>
        <div
          *ngIf="
            !authService.selectedProject ||
            authService.isProjectOwner(authService.selectedProject.id)
          "
        >
          <ion-button
            class="btn-large"
            style="margin: 15px 15px 30px 15px"
            (click)="newEmailTemplate()"
          >
            Create new email template
          </ion-button>
          <ion-button
            class="btn-large"
            style="margin: 15px 15px 30px 15px"
            (click)="newSlackTemplate()"
          >
            Create new Slack template
          </ion-button>
        </div>
      </div>
      <div
        class="side-list-container"
        *ngIf="myTemplates && myTemplates.length"
      >
        <h3>My templates</h3>
        <ion-grid class="grid-no-padding">
          <ion-row>
            <ion-col size="12">
              <ion-card class="my-template-card outline-card">
                <ion-list>
                  <ion-item
                    *ngFor="let tmp of myTemplates"
                    (click)="selectTemplate(tmp)"
                    button="true"
                  >
                    <ion-icon
                      slot="start"
                      [name]="tmp.type === 'slack' ? 'logo-slack' : 'mail'"
                      style="margin-right: 0"
                    >
                    </ion-icon>
                    <ion-label class="template-title">
                      {{ tmp.name }}
                    </ion-label>
                    <ion-label slot="end">
                      <ng-container *ngIf="!authService.selectedProject">
                        <strong>Project:</strong>
                        {{
                          tmp.projectId
                            ? getProjectName(tmp.projectId)
                            : "All projects"
                        }}
                        &nbsp;&nbsp;
                      </ng-container>
                      <strong>Updated:</strong>
                      {{ tmp.updatedAt | date: "MMM d yyyy h:mm a" }}
                    </ion-label>
                  </ion-item>
                </ion-list>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div
        class="side-list-container"
        *ngIf="sharedTemplates && sharedTemplates.length"
        style="border-top: 1px solid var(--ion-color-step-150)"
      >
        <h3>Templates shared by others</h3>
        <ion-grid class="grid-no-padding">
          <ion-row>
            <ion-col
              size-md="4"
              size-lg="3"
              size="12"
              *ngFor="let tmp of sharedTemplates"
            >
              <ion-card
                class="my-template-card card-flex outline-card depthButton"
                (click)="selectTemplate(tmp)"
                style="height: 160px"
              >
                <div class="cover"></div>
                <ion-card-subtitle class="template-type">
                  <ion-icon *ngIf="tmp.type === 'email'" name="mail"></ion-icon>
                  <ion-icon
                    *ngIf="tmp.type === 'slack'"
                    name="logo-slack"
                  ></ion-icon>
                </ion-card-subtitle>
                <ion-card-title class="template-title">
                  {{ tmp.name }}
                  <!-- <ion-icon name="chevron-forward-outline"></ion-icon> -->
                </ion-card-title>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div
        class="side-list-container"
        *ngIf="sampleTemplates && sampleTemplates.length"
      >
        <h3>Try a sample template</h3>
        <ion-grid class="grid-no-padding">
          <ion-row>
            <ion-col
              size-md="6"
              size-lg="4"
              size="12"
              *ngFor="let tmp of sampleTemplates"
            >
              <ion-card
                class="my-template-card card-flex outline-card depthButton"
                (click)="selectTemplate(tmp)"
                style="height: 300px; align-items: flex-end"
              >
                <img class="cover" *ngIf="tmp.image" src="{{ tmp.image }}" />
                <ion-card-title
                  style="
                    box-shadow: 0px 1px 20px 0px #57779333;
                    padding: 18px;
                    width: 100%;
                    margin: 0;
                    border-radius: 0;
                    background: #ffffff;
                  "
                  class="template-title"
                >
                  <ion-icon
                    [name]="tmp.type === 'slack' ? 'logo-slack' : 'mail'"
                    class="padded-icon"
                  ></ion-icon>
                  {{ tmp.name }}
                  <!-- <ion-icon name="chevron-forward-outline"></ion-icon> -->
                </ion-card-title>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>
</div>
